import { Component, EventEmitter, AfterViewInit, Input, OnInit, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/provider/config.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { h } from 'ionicons/dist/types/stencil-public-runtime';
import moment from 'moment';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'my-subscription-card',
  templateUrl: './my-subscription-card.component.html',
  styleUrls: ['./my-subscription-card.component.scss'],
  standalone: false,
})
export class MySubscriptionCardComponent implements OnInit, AfterViewInit {
  @Input() item: any;
  @Input() type: string = 'pending';
  @Input() remaining?: any;

  @Output() quantityChangeRequest = new EventEmitter<{ itemId: number; isPlusClick: boolean }>();
  @Output() freeze = new EventEmitter<any>();
  @Output() upgrade = new EventEmitter<{ sub: any }>();
  @Output() renew = new EventEmitter<{ route: any }>();
  @Output() pay = new EventEmitter<{ sub: any }>();
  @Output() cancel = new EventEmitter<{ sub: any }>();
  public progressVal: number = 0; // Initialize the property

  storeData: any = {};
  appL: string = 'en';
  public settings: any;
  private appSettingsSubscription: Subscription;

  private destroy$ = new Subject<void>(); // Added for managing subscriptions
  remainingDays: number;

  constructor(
    private translate: TranslateService,
    private configService: ConfigService,
    private cdRef: ChangeDetectorRef, // Keep ChangeDetectorRef if needed for internal async ops or special cases
    private theme: ThemeService, // Assuming you have a ThemeService for theme management
  ) {
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings) => {
      this.settings = currentSettings;
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
      this.appL = this.settings.appLanguage;
    });
  }

  ngOnInit = async () => {};
  calculateProgress(item: any): number {
    const startDate = moment(item.start_date);
    const endDate = moment(item.end_date);
    const currentDate = moment();

    // 1. Calculate the total duration of the period in days
    const totalDurationDays = endDate.diff(startDate, 'days');

    // Handle cases where totalDurationDays might be zero or negative
    if (totalDurationDays <= 0) {
      // If the end date is on or before the start date, or they are the same,
      // it's not a valid duration for this calculation.
      // Return 0 for invalid/no duration.
      return 0;
    }

    // 2. Calculate the elapsed duration from the start date to the current date
    //    If current date is before start date, elapsedDays will be negative or zero.
    const elapsedDays = currentDate.diff(startDate, 'days');

    // 3. Calculate the percentage
    let percentage: number;

    if (currentDate.isSameOrAfter(endDate)) {
      // If current date is past or on the end date, progress is 100%
      percentage = 100;
      // this.remainingDays = 0
      this.remainingDays = this.remaining;
    } else if (currentDate.isSameOrBefore(startDate)) {
      // If current date is on or before the start date, progress is 0%
      percentage = 0;
      this.remainingDays = this.remaining;
      // this.remainingDays = this.remaining; // All days are remaining
      // this.remainingDays = totalDurationDays;
    } else {
      // Otherwise, calculate based on elapsed time relative to total duration
      // this.remainingDays = endDate.diff(currentDate, 'days');
      this.remainingDays = this.remaining;
      percentage = (elapsedDays / totalDurationDays) * 100;
      // Ensure percentage is between 0 and 100
      percentage = Math.max(0, Math.min(100, percentage));
    }

    // You might want to round or fix the number of decimal places
    return parseFloat(percentage.toFixed(2)); // Rounds to 2 decimal places
  }

  async ngAfterViewInit() {
    this.storeData = await this.configService.configurationsSync();
    this.remainingDays = this.remaining;

    this.progressVal = this.calculateProgress(this.item);
    this.cdRef.detectChanges();

    // Removed this.cdRef.detectChanges(); - With OnPush, inputs are detected automatically.
  }

  ngOnDestroy() {
    this.destroy$.next(); // Emit to signal component destruction
    this.destroy$.complete(); // Complete the subject
  }

  upgradeClick() {
    this.upgrade.emit(this.item);
    this.cdRef.detectChanges();
  }
  payClick() {
    this.pay.emit(this.item);
    this.cdRef.detectChanges();
  }
  cancelClick() {
    this.cancel.emit(this.item.id);
    this.cdRef.detectChanges();
  }

  freezeClick() {
    this.freeze.emit();
    this.cdRef.detectChanges();
  }

  onMenuDetailPage() {
    this.renew.emit(this.item);
    // this.theme.setTheme('dark3');
  }

  handleClick1() {
    if (this.type !== 'pending') {
      this.freezeClick();
      // this.theme.setTheme('dark');
      this.cdRef.detectChanges();
      //  window.location.reload();
    } else {
      this.cancelClick();
      // this.theme.setTheme('dark2');
      this.cdRef.detectChanges();
      //  window.location.reload();
    }
  }
  handleClick2() {
    if (this.type !== 'pending') {
      this.upgradeClick();
      // this.theme.setTheme('light');
      this.cdRef.detectChanges();
      //  window.location.reload();
    } else {
      this.payClick();
      // this.theme.setTheme('light2');
      this.cdRef.detectChanges();
      //  window.location.reload();
    }
  }
  renewClick() {
    // this.theme.setTheme('dark3');
    this.renew.emit();
    this.cdRef.detectChanges();
    // this.cdRef.detectChanges();
    //  window.location.reload();
  }
  onSelectFoodMenu() {
    if (this.item.quantity == 0) {
      this.freezeClick();
    } else {
      this.upgradeClick();
    }
  }

  getShortTitle = (data: string): string => {
    if (!data) return '';
    if (data.length > 39) {
      return data.substring(0, 39) + '...';
    }
    return data;
  };

  getShortDesc = (data: string): string => {
    if (!data) return '';
    if (data.length > 90) {
      return data.substring(0, 90) + '...';
    }
    return data;
  };

  getParseFloat = (num: any): number => {
    return Number(parseFloat(num).toFixed(0));
  };
}
